import { IonIcon } from '@ionic/react'
import { checkmarkCircle } from 'ionicons/icons'

import { useStep } from './step'

import type { Children } from '../../../../types'

function StepHeading({ children }: Children) {
  const { isComplete, step } = useStep()

  return (
    <div className="flex items-center gap-2 py-4">
      <div className="bg-ion-color-yellow flex size-8 items-center justify-center rounded-full py-2 font-semibold text-gray-900">
        {step}
      </div>
      <h3 className="py-2 text-xl font-semibold text-white">{children}</h3>
      {isComplete ? (
        <IonIcon
          icon={checkmarkCircle}
          color="success"
          className="ml-2"
          size="large"
        />
      ) : null}
    </div>
  )
}

export { StepHeading }
